export const allSeoLandingLinks = [
  { to: "/birthday-decoration-in-delhi", label: "Birthday Decoration in Delhi" },
  { to: "/birthday-decoration-in-ghaziabad", label: "Birthday Decoration in Ghaziabad" },
  { to: "/birthday-decoration-in-noida", label: "Birthday Decoration in Noida" },
  { to: "/birthday-decoration-in-gurgaon", label: "Birthday Decoration in Gurgaon" },
  { to: "/birthday-decoration-in-faridabad", label: "Birthday Decoration in Faridabad" },
  { to: "/first-birthday-decoration-in-delhi", label: "First Birthday Decoration in Delhi" },
  { to: "/balloon-decoration-in-delhi", label: "Balloon Decoration in Delhi" },
  { to: "/balloon-decoration-in-ghaziabad", label: "Balloon Decoration in Ghaziabad" },
  { to: "/balloon-decoration-in-noida", label: "Balloon Decoration in Noida" },
  { to: "/balloon-decoration-in-gurgaon", label: "Balloon Decoration in Gurgaon" },
  { to: "/balloon-decoration-in-faridabad", label: "Balloon Decoration in Faridabad" },
  { to: "/baby-shower-decoration-in-delhi", label: "Baby Shower Decoration in Delhi" },
  { to: "/welcome-baby-decoration-in-delhi", label: "Welcome Baby Decoration in Delhi" },
  { to: "/welcome-baby-decoration-in-ghaziabad", label: "Welcome Baby Decoration in Ghaziabad" },
  { to: "/welcome-baby-decoration-in-noida", label: "Welcome Baby Decoration in Noida" },
  { to: "/anniversary-decoration-in-delhi", label: "Anniversary Decoration in Delhi" },
  { to: "/anniversary-decoration-in-ghaziabad", label: "Anniversary Decoration in Ghaziabad" },
  { to: "/anniversary-decoration-in-noida", label: "Anniversary Decoration in Noida" },
  { to: "/bride-to-be-decoration-in-delhi", label: "Bride To Be Decoration in Delhi" },
  { to: "/jungle-theme-decoration-in-delhi", label: "Jungle Theme Decoration in Delhi" },
  { to: "/barbie-theme-decoration-in-delhi", label: "Barbie Theme Decoration in Delhi" },
  { to: "/cocomelon-theme-decoration-in-delhi", label: "Cocomelon Theme Decoration in Delhi" },
  { to: "/boss-baby-theme-decoration-in-delhi", label: "Boss Baby Theme Decoration in Delhi" },
  { to: "/unicorn-theme-decoration-in-delhi", label: "Unicorn Theme Decoration in Delhi" },
  { to: "/butterfly-theme-decoration-in-delhi", label: "Butterfly Theme Decoration in Delhi" },
  { to: "/spiderman-theme-decoration-in-delhi", label: "Spiderman Theme Decoration in Delhi" },
  { to: "/mickey-mouse-theme-decoration-in-delhi", label: "Mickey Mouse Theme Decoration in Delhi" },
];

export const relatedExistingDecorLinks = [
  { to: "/subcategory/first-birthday-decorations", label: "First Birthday Decorations" },
  { to: "/subcategory/anniversary-decoration", label: "Anniversary Decoration" },
  { to: "/subcategory/welcome-baby-decoration", label: "Welcome Baby Decoration" },
  { to: "/subcategory/baby-shower-decoration", label: "Baby Shower Decoration" },
  { to: "/subcategory/bride-to-be-decoration", label: "Bride to Be Decoration" },
  { to: "/subcategory/wedding-events", label: "Wedding Events" },
];

export function seoLinksExcept(pathname) {
  return allSeoLandingLinks.filter((item) => item.to !== pathname);
}
